<div data-testid="step-7-2-rfi-invitation-preview">
  <p-tabs
    appTabsUnsavedReveal
    [value]="activeTabIndex()"
    data-testid="rfi-invitation-preview-tabs"
    (valueChange)="onTabChange($event!)"
    scrollable
  >
    <p-tablist data-testid="rfi-invitation-preview-tablist">
      <p-tab
        [value]="0"
        [appTabStatus]="mailPreviewTabStatus.signal()"
        data-testid="tenderWizard-mail-preview-tab"
      >
        {{ 'project.steps.rfi.invitationPreview.tabMailPreview' | transloco }}
      </p-tab>
      <p-tab
        [value]="1"
        [appTabStatus]="rfiProjectDescriptionTabStatus.signal()"
        data-testid="tenderWizard-project-description-tab"
      >
        {{ 'project.steps.rfi.invitationPreview.tabProjectDescription' | transloco }}
      </p-tab>
    </p-tablist>
    <p-tabpanels class="mt-6" data-testid="rfi-invitation-preview-tabpanels">
      <p-card data-testid="rfi-invitation-preview-card">
        <p-tabpanel [value]="0" data-testid="tenderWizard-mail-preview-tab-panel">
          @if (loadedTabs().has(0)) {
            <app-step-5-2-rfi-mail-preview
              [preloadedData]="invitationPreviewResponse()"
              [stepLocked]="isButtonDisabled()"
              (statusChange)="onMailPreviewStatusChange($event)"
            >
            </app-step-5-2-rfi-mail-preview>
          }
        </p-tabpanel>
        <p-tabpanel [value]="1" data-testid="tenderWizard-project-description-tab-panel">
          @if (loadedTabs().has(1)) {
            <app-step-7-2-rfi-project-description
              [preloadedData]="invitationPreviewResponse()"
              [stepLocked]="isButtonDisabled()"
              (statusChange)="onRfiProjectDescriptionStatusChange($event)"
            >
            </app-step-7-2-rfi-project-description>
          }
        </p-tabpanel>
      </p-card>
    </p-tabpanels>
  </p-tabs>
</div>
